import { useBriefing } from "@/context/BriefingContext";

export default function Footer() {
  const { openBriefing } = useBriefing();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[color:var(--g1-rule)] mt-0"
    >
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 lg:px-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 py-16 md:py-24">
          <div className="md:col-span-5">
            <div className="g1-label mb-6">/ Giga One</div>
            <p className="g1-h2 text-3xl md:text-4xl max-w-[22ch]">
              The operating system for the autonomous pharmaceutical factory.
            </p>
            <button
              type="button"
              data-testid="footer-request-briefing"
              onClick={openBriefing}
              className="g1-btn g1-btn-ghost mt-10"
            >
              Request Briefing
              <span className="g1-btn-arrow" aria-hidden>
                →
              </span>
            </button>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <div className="g1-label mb-6">/ Contents</div>
            <ul className="flex flex-col gap-3">
              {[
                ["#thesis", "01 — Thesis"],
                ["#pharma", "02 — Wedge"],
                ["#schematic", "03 — Platform"],
                ["#dark-factory", "04 — Dark Factory"],
                ["#differentiation", "05 — Difference"],
                ["#strategic", "06 — Sovereignty"],
                ["#signals", "07 — Signals"],
              ].map(([href, label]) => (
                <li key={href}>
                  <a
                    href={href}
                    className="font-mono text-[12px] tracking-[0.1em] uppercase text-[color:var(--g1-ink-2)] hover:text-[color:var(--g1-ink)] transition-colors"
                    data-testid={`footer-link-${label
                      .replace(/\s|—/g, "")
                      .toLowerCase()}`}
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 pb-10 border-t border-[color:var(--g1-rule)] pt-8">
          <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-[color:var(--g1-ink-3)]">
            © {year} Giga One. All rights reserved.
          </div>
          <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-[color:var(--g1-ink-3)]">
            Confidential — For qualified audiences only.
          </div>
        </div>
      </div>
    </footer>
  );
}
